import { initialState } from './initialState';
import { createReducer, dataAs, requestCases } from './requestState';

export default createReducer(initialState, {
  ...requestCases('UPDATE_PROFILES', { success: dataAs('profile_Data') }),
  ...requestCases('DEL_IMAGE', { success: dataAs('del_image_Data') }),
  ...requestCases('GET_IMAGE', { success: dataAs('get_image_Data') }),
  ...requestCases('GET_CATEGORY', { success: dataAs('get_category_Data') }),
  ...requestCases('GET_ANSWER', { success: dataAs('get_answer_Data') }),
});
